"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportAsCsv = exportAsCsv;
const CsvFile_1 = require("@juvare/data-import-ui/CsvFile");
const getIdsForAction_1 = require("./getIdsForAction");
async function exportAsCsv(props, storage, selectedRowIds, filterData, sortColumnKey, sortColumnDesc, all) {
    if (!props.csvFileHeader) {
        return '';
    }
    const csvFile = {
        header: props.csvFileHeader,
        rows: [],
    };
    if (props.mapListRowToCsvRow) {
        const batchSize = 5000;
        let offset = 0;
        let hasMore = true;
        while (hasMore) {
            const response = await storage.list({
                filter: props.mapFilter ? props.mapFilter(filterData) : undefined,
                orderBy: [{ column: sortColumnKey, desc: sortColumnDesc }],
                limit: batchSize,
                offset: offset,
            });
            if (response.rows.length === 0) {
                hasMore = false;
            }
            else {
                for (const row of response.rows) {
                    csvFile.rows.push(await props.mapListRowToCsvRow(row));
                }
                offset += response.rows.length;
                if (response.rows.length < batchSize) {
                    hasMore = false;
                }
            }
        }
        return (0, CsvFile_1.stringifyCsvFileToDataUrl)(csvFile);
    }
    else if (props.mapDataToCsvRow) {
        const ids = await (0, getIdsForAction_1.getIdsForAction)(props, storage, selectedRowIds, filterData, sortColumnKey, sortColumnDesc, all);
        for (const id of ids) {
            const response = await storage.get(id);
            csvFile.rows.push(await props.mapDataToCsvRow(response));
        }
        return (0, CsvFile_1.stringifyCsvFileToDataUrl)(csvFile);
    }
    else {
        return '';
    }
}
